import MainAdmin from './MainAdmin';

export default MainAdmin;
